function createExtensionInput(extensionData, config) {
  if (process.env.NODE_ENV !== "production") {
    if (Array.isArray(extensionData)) {
      const seen = /* @__PURE__ */ new Set();
      const duplicates = [];
      for (const dataRef of extensionData) {
        if (seen.has(dataRef.id)) {
          duplicates.push(dataRef.id);
        } else {
          seen.add(dataRef.id);
        }
      }
      if (duplicates.length > 0) {
        throw new Error(
          `ExtensionInput may not have duplicate data refs: '${duplicates.join(
            "', '"
          )}'`
        );
      }
    }
  }
  return {
    $$type: "@backstage/ExtensionInput",
    extensionData,
    config: {
      singleton: Boolean(config?.singleton),
      optional: Boolean(config?.optional)
    },
    replaces: config?.replaces
  };
}

export { createExtensionInput };
//# sourceMappingURL=createExtensionInput.esm.js.map
